import { useEffect, useState } from "react";
import { Phone, MessageCircle, ChevronRight } from "lucide-react";

export default function StickyMobileBar({ phone, whatsapp, onRegister }) {
    const [show, setShow] = useState(false);
    useEffect(() => {
        const onScroll = () => setShow(window.scrollY > 400);
        window.addEventListener("scroll", onScroll, { passive: true });
        onScroll();
        return () => window.removeEventListener("scroll", onScroll);
    }, []);
    if (!show) return null;
    const wa = (whatsapp || "").replace(/[^\d+]/g, "");
    return (
        <div
            data-testid="sticky-mobile-bar"
            className="fixed bottom-0 inset-x-0 z-40 md:hidden bg-white/95 backdrop-blur border-t border-slate-200 shadow-[0_-8px_30px_rgba(0,0,0,0.08)]"
        >
            <div className="grid grid-cols-3 gap-2 p-2">
                <a
                    data-testid="mobile-call-btn"
                    href={`tel:${phone}`}
                    className="flex flex-col items-center justify-center rounded-xl bg-brand-navyLight border border-brand-navy/10 py-2 text-brand-navy"
                >
                    <Phone className="w-5 h-5 text-brand-navy" />
                    <span className="text-[11px] mt-0.5 font-bold">Call</span>
                </a>
                <a
                    data-testid="mobile-whatsapp-btn"
                    href={`https://wa.me/${wa}?text=${encodeURIComponent(
                        "नमस्कार, मला Energy Plus बद्दल माहिती हवी आहे."
                    )}`}
                    target="_blank"
                    rel="noreferrer"
                    className="flex flex-col items-center justify-center rounded-xl bg-emerald-50 border border-emerald-200 py-2 text-emerald-900"
                >
                    <MessageCircle className="w-5 h-5" />
                    <span className="text-[11px] mt-0.5 font-bold">WhatsApp</span>
                </a>
                <button
                    data-testid="mobile-register-btn"
                    onClick={onRegister}
                    className="flex items-center justify-center rounded-xl bg-orange-gradient text-white font-bold text-sm shadow-orange active:scale-95 gap-1"
                >
                    नोंदणी <ChevronRight className="w-4 h-4" />
                </button>
            </div>
        </div>
    );
}
